module.exports = __webpack_public_path__ + "img/success.d269bc54.png";